































import { Component, Prop, Vue } from "vue-property-decorator";
import QErrors from "../../common/qErrors.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import contractMoveOutApi from "@/api/contractMoveOutApi";
import {
  ContractMovingOutHistoryItem,
  CONTRACT_MOVING_OUT_HISTORY,
} from "@/model/contract";


@Component({
  name: "contractMoveOutHistory",
  components: {
    QErrors,
    QTableHeader,
  },
})
export default class ContractMoveOutHistory extends Vue {
  @Prop()
  contractMoveOutId;
  @Prop({ default: CONTRACT_MOVING_OUT_HISTORY.STATUS_MOVE_OUT })
  status;
  query: Record<string, never>;

  public contractHistoryList: ContractMovingOutHistoryItem[] = [];
  public search = this.searchInital();
  public headers = [
    { id: "created_at", name: "日付", order: "desc" },
    { id: "username", name: "編集者" },
    { id: "content", name: "内容" },
  ];
  public searchInital() {
    return {
      status: this.status,
      created_at: null,
      username: null,
      content: null,
      sort: "created_at",
      direction: "desc",
      per_page: 10000,
    };
  }

  mounted() {
    this.initalSearch(null);
    this.getHistory(this.search);
  }

  public async getHistory(query) {
    query = { ...query, ...this.search };

    const response = await contractMoveOutApi.getHistory(this.contractMoveOutId, query);
    this.contractHistoryList = response.list;
  }

  public initalSearch(parameters: any): void {
    const query = parameters || this.$router.currentRoute.query;
    this.search = {
      ...this.search,
      ...query,
    };
  }

  public doSearch(query: any): void {
    this.getHistory(query);
  }
}
